import { LoadableAfterPaint } from '@confluence/loadable';

export const OBJECT_SIDEBAR_FG = 'confluence_frontend_object_sidebar';

export { PanelName } from './PanelName';
export { useObjectSidebar } from './useObjectSidebar';

export const ObjectSidebarControl = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ObjectSidebarControl" */ './components/ObjectSidebarControl'
			)
		).ObjectSidebarControl,
});
